<!--
 * @Author: your name
 * @Date: 2021-03-15 13:11:32
 * @LastEditTime: 2021-03-19 10:33:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \model\src\components\other\menu\DshMenu.vue
-->
<template>
    <div class="DshMenu">
        <template v-for="subMenu in menuList" >
            <div
                v-if="subMenu.menuItems.length < 1 && subMenu.children.length < 1"
                class="DshMenu-first"
                :key="subMenu._id"
            >
                <MenuItem
                    :name="subMenu._id"
                >
                    <Icon v-if="subMenu.icon" class="DshMenu-first-icon" :custom="subMenu.icon"/>
                    <Icon v-else :custom="'bico-font bico-' + $appData.customIcons[subMenu.menuType]" />
                    <span>{{ subMenu.name }}</span>
                </MenuItem>
            </div>
            <Submenu
                v-else
                :key="subMenu._id"
                class="DshMenu-submenu"
                :name="subMenu._id"
            >
                <template slot="title">
                    <Icon :custom="`bico-font ${subMenu.icon || 'bico-file'}`" />
                    {{ subMenu.name }}
                </template>

                <!-- 目录下菜单项 -->
                <MenuItem
                    v-for="menuItem in subMenu.menuItems"
                    :key="menuItem._id"
                    :name="menuItem._id"
                >
                    <Icon
                        v-if="showMenuIcon"
                        :custom="'bico-font bico-' + $appData.customIcons[menuItem.menuType]"
                    />
                    <span>{{ menuItem.name }}</span>
                </MenuItem>

                <!-- 次级目录 循环-->
                <dsh-menu
                    :menuList="subMenu.children"
                    :showMenuIcon="showMenuIcon"
                ></dsh-menu>
            </Submenu>
        </template>
        <!-- 一级 -->
    </div>
</template>

<script>
    export default {
        name: "DshMenu",
        props: {
            showMenuIcon: {
                type: Boolean,
                default: true
            },
            menuList: {
                type: Array,
                default () {
                    return [];
                }
            }
        },
        data () {
            return {
            };
        },
        computed: {
        },
        created () {
        },
        methods: {
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/menu/DshMenu.vue